# Handles the hover/tooltips throughout the UI
# Tooltips show up after a set delay. Once a tooltip is triggered, other tooltips show up without delay.
PT.Utils.Tooltip = class Tooltip
  constructor: ->
    @document = $(document)
    @defaultDelay = 500
    @currentDelay = @defaultDelay

    @document
      .on('mouseenter', '[data-pt-tooltip]', @onMouseEnter)
      .on('mouseleave', '[data-pt-tooltip]', @onMouseLeave)
      .on('click', '[data-pt-tooltip]', @onClick)

  ## Methods

  getDelay: (tooltip) ->
    # bail early when there is no delay
    return 0 if @currentDelay is 0

    customDelay = tooltip.getAttribute('data-pt-tooltip-delay')

    # custom delay overrides
    if customDelay?
      customDelay
    else
      @currentDelay

  setDelay: (delay) ->
    @currentDelay = delay

  hideTooltip: (tooltip) ->
    clearTimeout $(tooltip).data('el-tooltip-timeout-id')
    tooltip.classList.remove 'tooltip-on'

    # back to original delay
    @document.data('doc-tooltip-timeout-id', setTimeout =>
      @setDelay @defaultDelay
    , 500)

  showTooltip: (tooltip) ->
    tooltip.classList.add 'tooltip-on'

  ## Event Handlers

  onMouseEnter: (e) =>
    clearTimeout @document.data('doc-tooltip-timeout-id')

    # show tooltip after a delay
    $(e.currentTarget).data('el-tooltip-timeout-id', setTimeout =>

      # set delay to 0 so subsequent tooltips show immediately
      @setDelay 0

      @showTooltip e.currentTarget
    , @getDelay(e.currentTarget))

  onMouseLeave: (e) =>
    @hideTooltip e.currentTarget

  onClick: (e) =>
    if e.currentTarget.getAttribute('data-pt-tooltip-hide-trigger') is 'click'
      @hideTooltip e.currentTarget
